import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Size } from 'coreOld/enums';

interface ContentWrapperProps {
  isOpen?: boolean;
  children?: ReactNode;
  style?: CSSProperties;
}

export const ContentWrapper = styled.div<ContentWrapperProps>`
  overflow: hidden;
  transition: height 0.4s ease-in-out;
  max-height: calc(100vh - 240px);
  overflow-y: auto;

  ${({ isOpen }) =>
    isOpen &&
    css`
      border-bottom: 1px solid #dee2e6;
    `}
`;

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  transition: 0.4s;
`;

interface ContainerProps {
  children?: ReactNode;
  style?: CSSProperties;
}

export const Container = styled.div<ContainerProps>`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 99;
  background-color: #d7d7d7;
`;

interface ChildrenWrapperProps {
  children?: ReactNode;
}

export const ChildrenWrapper = styled.div<ChildrenWrapperProps>`
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  width: auto;
`;

interface BoxProps {
  children?: ReactNode;
}

export const Box = styled.div<BoxProps>`
  display: flex;
  justify-content: space-between;
  padding: 10px 32px 14px 27px;
`;

interface TextProps {
  fontSize?: Size;
  children?: ReactNode;
}

export const Text = styled.div<TextProps>`
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  color: ${({ theme }) => theme.palette.neutral.dark};

  ${({ fontSize }) => {
    switch (fontSize) {
      case Size.SM:
        return css`
          font-size: 22px;
        `;
      case Size.MD:
        return css`
          font-size: 32px;
        `;
      default:
        return css``;
    }
  }}
`;

interface TopElementsProps {
  children?: ReactNode;
}

export const TopElements = styled.div<TopElementsProps>`
  display: flex;
  justify-content: space-between;
  padding: 10px 32px 10px 27px;
  align-items: flex-end;
`;

interface CloseButtonProps {
  children?: ReactNode;
  onClick?: any;
}

export const CloseButton = styled.button<CloseButtonProps>`
  font-size: 30px;
  color: #555;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: flex-end;

  &:hover {
    cursor: pointer;
  }
`;

interface DivProps {
  children?: ReactNode;
  ref?: any;
}

export const Div = styled.div<DivProps>``;
